import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import {
  IUseUpdateMutation,
  IUpdateFn,
  IGetPutRequest,
  ISafetyReportAnswer,
  ISafetyReportAnswerUpdateUpsert,
} from '../../interfaces'

const getUpdateSafetyReportInternalAnswerMutationRequest: IGetPutRequest = params => {
  return {
    method: 'put',
    url: `${config.baseUrl}/sms/SafetyReportAnswers/`,
  }
}

const useUpdateSafetyReportInternalAnswerMutation: IUseUpdateMutation<
  ISafetyReportAnswer,
  ISafetyReportAnswerUpdateUpsert
> = (params, options = {}) => {
  const request = useMemo(() => getUpdateSafetyReportInternalAnswerMutationRequest(params), [params])

  const updateTraining: IUpdateFn<ISafetyReportAnswerUpdateUpsert, ISafetyReportAnswer> = useCallback(
    async data => {
      return axios({ ...request, url: request.url + data.id, data }).then(res => res.data)
    },
    [request],
  )

  const response = useMutation<ISafetyReportAnswer, Error, any>({
    mutationFn: updateTraining,
    ...options,
  })

  return response
}

export default useUpdateSafetyReportInternalAnswerMutation
